import { moduleName } from '@/constants/global/module';
import { CustomRouteRecord } from '@/types/router/router';

const CustomerInsight = () => import('@/views/modules/customer-insight/customer-insight/CustomerInsight.vue');
const CustomerInsightConfig = () => import('@/views/modules/customer-insight/customer-insight-config/CustomerInsightConfig.vue');
const CustomerInsightExportPreviewVue = () =>
  import('@/views/modules/customer-insight/customer-insight-export-preview/CustomerInsightExportPreview.vue');
const CustomerInsightManageProps = () => import('@/views/modules/customer-insight/customer-insight-manage-props/CustomerInsightManage.vue');
import { segmentVersionKey } from '@/constants/modules/segment-v2/segment-adaptor';

const customerInsightBreadcrumb = [
  {
    text: 'Segment',
    to: '/segment/data-segment/main',
  },
];

const meta = {
  moduleName: moduleName.CustomerInsight,
  moduleVersion: '1.0.0',
};

const customerInsightRoutes: Array<CustomRouteRecord> = [
  {
    path: '/customer-profile',
    redirect: { name: 'customerProfileDashboard' },
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'Segment',
        versionKey: segmentVersionKey,
        versionTo: {
          '1.0.0': '/segment/data-segment/main',
          '2.0.0': '/segmentv2',
        },
      },
      {
        text: 'main_menu.dashboard',
        active: true,
      },
    ],
  },

  {
    path: '/customer-profile/config/:pageId?',
    name: 'customerProfileConfig',
    component: CustomerInsightConfig,
    meta: {
      ...meta,
    },
    breadcrumb: [
      ...customerInsightBreadcrumb,
      {
        text: 'segment.setting_dashboard',
        active: true,
      },
    ],
  },
  {
    path: '/customer-profile/:cId?/:pageId?',
    name: 'customerProfileDashboard',
    component: CustomerInsight,
    meta: {
      ...meta,
    },
    breadcrumb: [
      ...customerInsightBreadcrumb,
      {
        text: 'Customer Insight',
        active: true,
      },
    ],
  },
  {
    path: '/customer-profile/export-preview',
    name: 'export-preview',
    component: CustomerInsightExportPreviewVue,
    meta: {
      ...meta,
      layout: 'full',
    },
    breadcrumb: [
      {
        text: 'bi.dashboard',
      },
    ],
  },
  {
    path: '/customer-profile/manage-property',
    name: 'manage-property',
    component: CustomerInsightManageProps,
    meta: {
      ...meta,
    },
    breadcrumb: [
      ...customerInsightBreadcrumb,
      {
        text: 'segment.setting_dashboard',
        to: '/customer-profile/config/:pageId?',
      },
      {
        text: 'segment.profile',
        to: '/customer-profile/config/:pageId?',
      },
      {
        text: 'segment.manage_property',
        active: true,
      },
    ],
  },
];

export default customerInsightRoutes;
